module.exports = __webpack_public_path__ + "handbold_round-f8879d365eeeb725d4474c9e7a83b84b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/dk/handbold_round.png
// module id = 1161
// module chunks = 1 2